import { render, staticRenderFns } from "./Vitals.vue?vue&type=template&id=565d3bf6&"
import script from "./Vitals.vue?vue&type=script&lang=js&"
export * from "./Vitals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports